<script>
  import { algoliaClientId, algoliaSearchKey } from '../tenant';
  import { isAuthenticated, userInfo } from '@dopry/svelte-auth0';
  import algoliasearch from 'algoliasearch/lite';
  import { Container } from 'sveltestrap';
  import { onMount } from 'svelte';
  import DashboardOrder from './DashboardOrder.svelte';

  const fts = algoliasearch(algoliaClientId, algoliaSearchKey).initIndex(
    'order'
  );

  let page = 0,
    hitsPerPage = 500,
    orders = [];

  onMount(async () => {
    if ($isAuthenticated && $userInfo) {
      const stores = $userInfo['http://techsteward.com/app_metadata'].stores,
        filters = [
          ...[
            `orderEmail:${$userInfo.email}`,
            `approveEmail:${$userInfo.email}`,
          ],
          ...stores.map((x) => `store:${x}`),
        ].join(' OR ');
      orders = await fts.search('', { filters, hitsPerPage, page })
      orders = orders.hits.sort((orderA, orderB) => // sort by market, store -- override page rank
        orderA.market - orderB.market || orderA.store - orderA.store)
    }
  });
</script>

<Container>
  <div><strong>My Orders (placed or approved)</strong></div>
  {#each orders as order}
    <DashboardOrder {order} />
  {/each}
</Container>
